export const DEFAULT_SCENARIO_ID = 'scenario-default';
export const PAYBYLINK_VOUCHER_SCENARIO_ID = '05cf4';
export const PAYBYLINK_PTC_REDIRECTION_SCENARIO_ID = '168f9';
export const PAYBYLINK_CUSTOMER_SUPPORT_SCENARIO_ID = '1a2b3';
export const FAST_TRACK_SCENARIO_ID = 'fast-track';
export const PROMO_CODE_WIDGET_SCENARIO_ID = 'scenario-with-promo-code-widget';
export const CHECK_IN_FUNNEL_SCENARIO_ID = 'check-in-funnel';
